Object.defineProperty(exports, "__esModule", { value: true });
exports.naturaV3DarkColorTokens = exports.naturaV3LightColorTokens = void 0;
var natura_v3_light_1 = require("./natura_v3-light");
Object.defineProperty(exports, "naturaV3LightColorTokens", { enumerable: true, get: function () { return natura_v3_light_1.naturaV3LightColorTokens; } });
var natura_v3_dark_1 = require("./natura_v3-dark");
Object.defineProperty(exports, "naturaV3DarkColorTokens", { enumerable: true, get: function () { return natura_v3_dark_1.naturaV3DarkColorTokens; } });
//# sourceMappingURL=index.js.map